import fr from '../../translation/fr_FR'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'fr',
        iso: 'fr-FR',
      },
    ],
    defaultLocale: 'fr',
    vueI18n: {
      fallbackLocale: 'fr',
      messages: {
        fr,
      },
    },
    pages: {
      'categories/inspirations': {
        fr: '/inspirations',
      },
      'categories/gifts': {
        fr: '/cadeaux',
      },
      'categories/occasions': {
        fr: '/occasions',
      },
      'categories/tutorials-and-advices': {
        fr: '/tutoriels-et-conseils',
      },
      'categories/home-furnishing': {
        fr: '/decoration-interieure',
      },
      'editorial-staff/index': {
        fr: '/redazione',
      },
      'editorial-staff/_author': {
        fr: '/redazione/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/?page_id=122',
      },
      {
        key: 'inspirations',
        wpUri: '/?page_id=124',
      },
      {
        key: 'gifts',
        wpUri: '/?page_id=126',
      },
      {
        key: 'occasions',
        wpUri: '/?page_id=137',
      },
      {
        key: 'tutorials-and-advices',
        wpUri: '/?page_id=130',
      },
      {
        key: 'home-furnishing',
        wpUri: '/?page_id=128',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redazione/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'inspirations',
        wpSlug: 'inspirations',
        view: 'categories-inspirations',
        wpCategoryId: 4,
      },
      {
        key: 'gifts',
        wpSlug: 'gifts',
        view: 'categories-gifts',
        wpCategoryId: 5,
      },
      {
        key: 'occasions',
        wpSlug: 'occasions',
        view: 'categories-occasions',
        wpCategoryId: 6,
      },
      {
        key: 'tutorials-and-advices',
        wpSlug: 'tutorials-and-advices',
        view: 'categories-tutorials-and-advices',
        wpCategoryId: 7,
      },
      {
        key: 'home-furnishing',
        wpSlug: 'home-furnishing',
        view: 'categories-home-furnishing',
        wpCategoryId: 8,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 3,
      },
    ],
  },
  giftaWebsite: 'https://www.gifta.fr/',
  navigation: {
    primary: {
      order: [
        'inspirations',
        'gifts',
        'occasions',
        'tutorials-and-advices',
        'home-furnishing',
      ],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/gifta.fr/',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/gifta.fr/',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://www.gifta.fr/privacy-policy/',
    },
    {
      key: 'cookie-policy',
      url: 'https://www.gifta.fr/cookie/',
    },
    {
      key: 'informazioni-legali',
      url: 'https://www.gifta.fr/mentions-legales/',
    },
  ],
  pixaLinks: [
    {
      key: 'books-magazines',
      url: 'https://www.pixartprinting.fr/impression-revues-catalogues-livres/',
    },
    {
      key: 'business-cards',
      url: 'https://www.pixartprinting.fr/cartes-de-visite/',
    },
    {
      key: 'flyers',
      url: 'https://www.pixartprinting.fr/petit-format/impression-flyers-tractes/',
    },
  ],
  shopLinks: [
    {
      label: 'Cadeaux personnalisés',
      url: 'https://www.gifta.fr/cadeau-personnalise/',
    },
    {
      label: 'Photo sur toile',
      url: 'https://www.gifta.fr/photo-sur-toile/',
    },
    {
      label: 'Tableaux personnalisés',
      url: 'https://www.gifta.fr/photo-sur-toile/tableau-canvas-personnalise/',
    },
    {
      label: 'Décoration murale',
      url: 'https://www.gifta.fr/decoration-murale/',
    },
    {
      label: 'Cadeaux photos',
      url: 'https://www.gifta.fr/cadeaux-photo/',
    },
    {
      label: 'Coussins personnalisés',
      url: 'https://www.gifta.fr/cadeaux-photo/coussin-personnalise/',
    },
    {
      label: 'Mugs personnalisés',
      url: 'https://www.gifta.fr/cadeaux-photo/mug-personnalise/',
    },
    {
      label: 'Tote bags personnalisés',
      url: 'https://www.gifta.fr/cadeaux-photo/tote-bag-personnalise/',
    },
    {
      label: 'T-shirts personnalisés',
      url: 'https://www.gifta.fr/t-shirt-personnalise/',
    },
    {
      label: 'Livres photos',
      url: 'https://www.gifta.fr/livres-photo/',
    },
    {
      label: 'Calendriers photo',
      url: 'https://www.gifta.fr/calendrier-photo/',
    },
    {
      label: 'Idées Cadeaux',
      url: 'https://www.gifta.fr/idee-de-cadeau/',
    },
  ],
  nuxtConfiguration: {
    head: {
      script: [
        {
          src: 'https://21fd768e7ea04855a8a850bd8ab542cf.js.ubembed.com',
          async: true,
        },
      ],
    },
  },
}
